import React, { HTMLAttributes } from 'react'

export interface DividerProps extends HTMLAttributes<HTMLHRElement> { }

export const Divider = (props: DividerProps): JSX.Element => (
    <hr {...props} className={`my-1 border-shade-200 ${props.className}`} aria-hidden />
)
